export default __webpack_public_path__ + "0c240cc.png";